import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, box2Like, vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const BlitOutOfBoundsHandling = z.union([z.literal("wrap"), z.literal("clip")])

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            foregroundRegion: z.optional(box2Like),
            foregroundAddressMode: z._default(AddressMode, "clamp"),
            position: z._default(vector2Like, {x: 0, y: 0}),
            outOfBoundsHandling: z._default(BlitOutOfBoundsHandling, "clip"),
            // Only safe when `backgroundImage` is provably not referenced by anything else in the graph (e.g. an
            // intermediate result this same caller produced and will not use again) - see clone-stamp's stroke loop.
            inPlace: z._default(z.boolean(), false),
        }),
    },
}
